import { useContext, useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useMediaQuery } from 'react-responsive'
import { ModalTotalContext } from '../../../../context/ModalContext'
import { ButtonSubmit } from '../../../../GlobalStyle'
import api from '../../../../hooks/API'
import { formatedData } from '../../../../hooks/FormatedValue'
import { breakpoints } from '../../../../MediasQueries'
import Header from '../../Header'
import InfoWrap from '../../InfoWrap'
import InputComponent from '../../Input'
import SelectTable from '../../TableProduct/SelectTable'
import Base from '../index'
import { ContentModal } from '../style'
import { InfosWrap } from './style'

const ModalAddProduct = ({ setComponents, components }) => {
  const isDesktop = useMediaQuery({ minWidth: breakpoints.md })
  const { setOpenModal } = useContext(ModalTotalContext)
  const [search, setSearch] = useState('')
  const [filterData, setFilterData] = useState(null)
  const [selected, setSelected] = useState(components)
  const [costTable, setcostTable] = useState(0)
  const { data: products, isLoading } = useQuery(['components'], () => api.getProducts())

  useEffect(() => {
    setFilterData(products)
  }, [])

  useEffect(() => {
    const filteredProducts = products.filter(
      (item) =>
        item.nome.toLowerCase().startsWith(search.toLowerCase()) ||
        item.id.toString().includes(search)
    )
    setFilterData(filteredProducts)
  }, [setSearch, search])

  const handleSubmit = () => {
    console.log(selected)
    setComponents((old) => {
      const newComponents = selected.filter((component) => !old.includes(component))
      const updatedOld = old.filter((component) => selected.includes(component))
      return [...updatedOld, ...newComponents]
    })
    setOpenModal(null)
  }

  if (isLoading) return <div>modal</div>

  return (
    <Base title={'Seleção de componentes'} width={isDesktop ? '70%' : '97%'} height={'90%'}>
      <ContentModal>
        <Header title={'Lista de componentes'} />
        <InputComponent
          height={'38px'}
          width={'100%'}
          placeholder="Pesquisar por componentes"
          margin={'0px 0px 0px 0px'}
          onChange={(e) => setSearch(e.target.value)}
        />

        <SelectTable
          padding={'15px 0px'}
          costTable={costTable}
          setcostTable={setcostTable}
          setSelected={setSelected}
          selected={selected}
          products={search.length > 0 ? filterData : products}
        />
      </ContentModal>
      <InfosWrap>
        <InfoWrap text={'Custo'} value={formatedData(costTable)} />
        <InfoWrap text={selected.length <= 1 ? 'Item' : 'Itens'} value={selected.length} />
        <ButtonSubmit type="button" margin={'0px'} height={'100%'} onClick={() => handleSubmit()}>
          Adicionar Componentes
        </ButtonSubmit>
      </InfosWrap>
    </Base>
  )
}
export default ModalAddProduct
